import { render, staticRenderFns } from "./giftcard.vue?vue&type=template&id=232ea6e4&scoped=true&"
import script from "./giftcard.vue?vue&type=script&lang=js&"
export * from "./giftcard.vue?vue&type=script&lang=js&"
import style0 from "./giftcard.vue?vue&type=style&index=0&id=232ea6e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232ea6e4",
  null
  
)

export default component.exports